import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, of, switchMap, tap } from 'rxjs';
import { getAllRouteData } from '../lib/get-all-route-data';
import { getFullPath } from '../lib/get-full-path';
import { GenericReplaceService } from '../services/generic-replace.service';
import { StorageService } from '../services/storage.service';
import { StoryblokReplaceService } from '../services/storyblok-replace.service';
import { StoryblokService } from '../services/storyblok.service';

export const storyblokStoryResolver = (route: ActivatedRouteSnapshot) => {
  const storage = inject(StorageService);
  const storyblokReplaceService = inject(StoryblokReplaceService);
  const genericReplacerService = inject(GenericReplaceService);
  const path = getAllRouteData(route).storyblokPathOverride || getFullPath(route).join('/') || 'home';
  const storyblokService = inject(StoryblokService);

  return storyblokService.getStory(path, route).pipe(
    map(resp => (resp && resp.story) || (false as const)),
    tap(story => {
      const promotionCode = story && story.content.promotionCode;
      if (promotionCode) storage.set('promo', promotionCode);
    }),
    switchMap(story => {
      if (!story) return of(story);
      return genericReplacerService.getGenericReplaceData(route).pipe(
        map(data => {
          if (!story.content.body) return;
          return storyblokReplaceService.replaceStoryValues(story, route, {
            ...data,
            relationships: [],
          });
        })
      );
    })
  );
};
